import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import loginBanner from "../assets/splitpos-login-banner.webp";
import splitPosLogo from "../assets/splitPosLogo.png";
import { postReqwithoutHeader } from "../utils/ApiClient";
import SpinnerComponent from "../components/SpinnerComponent";
import { isValidPassword } from "../utils/utils";
const CreatePassword = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [userPassword, setUserPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [formError, setFormError] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserPassword({ ...userPassword, [name]: value });
    const error = { ...formError };
    switch (name) {
      case "newPassword":
        error.newPassword =
          value.trim() === ""
            ? "Enter new password."
            : !isValidPassword(value)
              ? "Atleast one number, alphabet and one special character are required."
              : "";
        break;
      case "confirmPassword":
        error.confirmPassword =
          value.trim() === ""
            ? "Confirm password is required."
            : value !== userPassword.newPassword
              ? "Confirm password not matched."
              : "";
        break;
      default:
        break;
    }
    setFormError({ ...error });
  };
  const validate = () => {
    let error = true;
    const submitError = { ...formError };
    if (userPassword.newPassword === "") {
      error = false;
      submitError.newPassword = "New password is required.";
    } else if (userPassword.newPassword.length < 4) {
      error = false;
      submitError.newPassword = "New password must be more than 4 characters.";
    }
    if (userPassword.confirmPassword === "") {
      error = false;
      submitError.confirmPassword = "Confirm password is required.";
    } else if (userPassword.confirmPassword !== userPassword.newPassword) {
      error = false;
      submitError.confirmPassword =
        "Password and confirm password not matched.";
    }
    setFormError({ ...submitError });
    return error;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      var data = {
        password: userPassword.newPassword,
        emailToken: search.substring(12),
      };
      try {
        setLoading(true);
        const response = await postReqwithoutHeader("createPassword", data);
        const { status, message } = response.data;
        if (status === 200) {
          localStorage.clear();
          toast.success(message, {
            theme: "colored",
            autoClose: 950,
          });
          setLoading(false);
          navigate("/sign-in");
        } else {
          toast.error(message, {
            theme: "colored",
            autoClose: 950,
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong!";
        toast.error(errorMessage, {
          theme: "colored",
          autoClose: 950,
        });
      }
    } else {
      toast.error("Something went wrong!", {
        theme: "colored",
        autoClose: 950,
      });
      setLoading(false);
    }
  };

  const toggleNewPasswordVisibility = () => {
    setIsNewPasswordVisible((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible((prev) => !prev);
  };
  return (
    <React.Fragment>
      <section className="login-page-v2">
        <div className="container-fluid">
          <div className="row min-vh-100">
            <div className="col-lg-7 d-none d-lg-flex login-brand-panel">
              <img
                src={loginBanner}
                alt="SplitPOS"
                className="login-banner-image"
              />
            </div>
            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div className="login-card">
                <div className="text-center mb-4">
                  <div className="login-logo-wrapper">
                    <img
                      src={splitPosLogo}
                      alt="SplitPOS"
                      className="login-logo"
                    />
                  </div>
                  <div className="forgot-icon">
                    <i className="fa fa-key"></i>
                  </div>
                  <h2 className="mt-4">Create Password</h2>
                  <p className="text-muted">
                    Choose a secure password to protect your account.
                  </p>
                </div>
                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <div className="input-group password-group">
                    <input
                      type={isNewPasswordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="Enter new password"
                      name="newPassword"
                      value={userPassword?.newPassword}
                      onChange={handleChange}
                    />

                    <span
                      className="password-icon"
                      onClick={toggleNewPasswordVisibility}
                    >
                      <i
                        className={`fa ${
                          isNewPasswordVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                      />
                    </span>
                  </div>

                  <small className="text-danger">
                    {formError?.newPassword}
                  </small>
                </div>

                {/* Confirm Password */}
                <div className="mb-4">
                  <label className="form-label">Confirm Password</label>

                  <div className="input-group password-group">
                    <input
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm password"
                      name="confirmPassword"
                      value={userPassword?.confirmPassword}
                      onChange={handleChange}
                    />

                    <span
                      className="password-icon"
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      <i
                        className={`fa ${
                          isConfirmPasswordVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                      />
                    </span>
                  </div>

                  <small className="text-danger">
                    {formError?.confirmPassword}
                  </small>
                </div>

                {loading ? (
                  <button className="login-btn" disabled>
                    <SpinnerComponent />
                    Please wait...
                  </button>
                ) : (
                  <button className="login-btn" onClick={handleSubmit}>
                    Create Password
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
export default CreatePassword;
